// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__CARPx","addBtn":"Button_addBtn__HUil2","deleteBtn":"Button_deleteBtn__UyPrg","createBtn":"Button_createBtn__sK3aE","updateBtn":"Button_updateBtn__2M-uY"};